export default __webpack_public_path__ + "static/media/text-claim-now.c782c4f5.svg";